import React, { useContext, useEffect } from "react";
import { useState } from "react";

import { TableBody, TableRow } from "@mui/material";

import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell } from "../../../Styles/tabelCellStyled/customTableCell";
import { StyledTableHead } from "../../../Styles/tabelCellStyled/customTableCell";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { IPage5B_Two } from "../../../Interfaces/cadernos/caderno5/interfaces5B";
import { desformatarNumero, desformatarNumero_return_null, formatarNumero_ao_digitar } from "../../../Func_genericas/formatar_numero_formato_pt";
import { formatar_numeros_Atividades_ExtraTabela_5B } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/caderno5B";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";




interface IRegistoAtividadesExtraProps {
  idCabecalho: number;
  setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
}

export const RegistoAtividadesExtra: React.FC<IRegistoAtividadesExtraProps> = ({
  idCabecalho,
  setMessage,
  setOpenSnackError,
  setOpenSnackSuccess,
}) => {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  // Estado para os campos extra
  const [extraFields, setExtraFields] = useState<IPage5B_Two[]>([]);
  const [extraObject, setExtraObject] = useState<IPage5B_Two | undefined>();

  const [isLoading, setIsLoading] = useState(true);
  const [createTable, setCreateTable] = useState(false);
  const [openDeleteAtividades, setOpenDeleteExtra] = React.useState(false);

  const message_apenas_numero = ("Apenas números são aceites");

  const [error_elementos_n, set_error_elementos_n] = useState<boolean>(false);
  const [error_elementos_po, set_error_elementos_po] = useState<boolean>(false);
  const [error_elementos_ko, set_error_elementos_ko] = useState<boolean>(false);
  const [error_elementos_mgo, set_error_elementos_mgo] = useState<boolean>(false);
  const [error_elementos_cao, set_error_elementos_cao] = useState<boolean>(false);
  const [error_elementos_so, set_error_elementos_so] = useState<boolean>(false);
  const [error_elementos_b, set_error_elementos_b] = useState<boolean>(false);

  const [error_totais_apli_homo_n, set_error_totais_apli_homo_n] = useState<boolean>(false);
  const [error_totais_apli_homo_po, set_error_totais_apli_homo_po] = useState<boolean>(false);
  const [error_totais_apli_homo_ko, set_error_totais_apli_homo_ko] = useState<boolean>(false);
  const [error_totais_apli_homo_mgo, set_error_totais_apli_homo_mgo] = useState<boolean>(false);
  const [error_totais_apli_homo_cao, set_error_totais_apli_homo_cao] = useState<boolean>(false);
  const [error_totais_apli_homo_so, set_error_totais_apli_homo_so] = useState<boolean>(false);
  const [error_totais_apli_homo_b, set_error_totais_apli_homo_b] = useState<boolean>(false);

  const [error_totais_apli_n, set_error_totais_apli_n] = useState<boolean>(false);
  const [error_totais_apli_po, set_error_totais_apli_po] = useState<boolean>(false);
  const [error_totais_apli_ko, set_error_totais_apli_ko] = useState<boolean>(false);
  const [error_totais_apli_mgo, set_error_totais_apli_mgo] = useState<boolean>(false);
  const [error_totais_apli_cao, set_error_totais_apli_cao] = useState<boolean>(false);
  const [error_totais_apli_so, set_error_totais_apli_so] = useState<boolean>(false);
  const [error_totais_apli_b, set_error_totais_apli_b] = useState<boolean>(false);


  const camposNumericos = [
    "elementos_n", "elementos_po", "elementos_ko", "elementos_mgo", "elementos_cao", "elementos_so", "elementos_b",
    "totais_apli_homo_n", "totais_apli_homo_po", "totais_apli_homo_ko", "totais_apli_homo_mgo", "totais_apli_homo_cao", "totais_apli_homo_so", "totais_apli_homo_b",
    "totais_apli_n", "totais_apli_po", "totais_apli_ko", "totais_apli_mgo", "totais_apli_cao", "totais_apli_so", "totais_apli_b",
  ];
  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    set_error_elementos_n(false)
    set_error_elementos_po(false)
    set_error_elementos_ko(false)
    set_error_elementos_mgo(false)
    set_error_elementos_cao(false)
    set_error_elementos_so(false)
    set_error_elementos_b(false)
    set_error_totais_apli_homo_n(false)
    set_error_totais_apli_homo_po(false)
    set_error_totais_apli_homo_ko(false)
    set_error_totais_apli_homo_mgo(false)
    set_error_totais_apli_homo_cao(false)
    set_error_totais_apli_homo_so(false)
    set_error_totais_apli_homo_b(false)
    set_error_totais_apli_n(false)
    set_error_totais_apli_po(false)
    set_error_totais_apli_ko(false)
    set_error_totais_apli_mgo(false)
    set_error_totais_apli_cao(false)
    set_error_totais_apli_so(false)
    set_error_totais_apli_b(false)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    handleCancel()

  };

  async function getExtra(id: number) {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, `/get_reg_actividades_5b_two_cabecalho/${id}`);
      if (idCabecalho !== undefined) {
        if (res.status === 200) {
          const formattedData = res.data.result.map(formatar_numeros_Atividades_ExtraTabela_5B);

          setExtraFields(formattedData);
        }
      };
      setIsLoading(false);
    } catch (error) {
      func_print("getExtra", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getExtra(idCabecalho);
    })();
  }, [idCabecalho]);

  const handleCancel = () => {
    setCreateTable(false);
    setExtraObject(undefined);
  }

  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    const isCampoNumerico = camposNumericos.includes(name);
    set_flag_editado(true)

    if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));

      if (!isNaN(valorNumerico)) {
        if (name === "elementos_n") {
          set_error_elementos_n(false);
        } else if (name === "elementos_po") {
          set_error_elementos_po(false);
        } else if (name === "elementos_ko") {
          set_error_elementos_ko(false);
        } else if (name === "elementos_mgo") {
          set_error_elementos_mgo(false);
        } else if (name === "elementos_cao") {
          set_error_elementos_cao(false);
        } else if (name === "elementos_so") {
          set_error_elementos_so(false);
        } else if (name === "elementos_b") {
          set_error_elementos_b(false);
        } else if (name === "totais_apli_homo_n") {
          set_error_totais_apli_homo_n(false);
        } else if (name === "totais_apli_homo_po") {
          set_error_totais_apli_homo_po(false);
        } else if (name === "totais_apli_homo_ko") {
          set_error_totais_apli_homo_ko(false);
        } else if (name === "totais_apli_homo_mgo") {
          set_error_totais_apli_homo_mgo(false);
        } else if (name === "totais_apli_homo_cao") {
          set_error_totais_apli_homo_cao(false);
        } else if (name === "totais_apli_homo_so") {
          set_error_totais_apli_homo_so(false);
        } else if (name === "totais_apli_homo_b") {
          set_error_totais_apli_homo_b(false);
        } else if (name === "totais_apli_n") {
          set_error_totais_apli_n(false);
        } else if (name === "totais_apli_po") {
          set_error_totais_apli_po(false);
        } else if (name === "totais_apli_ko") {
          set_error_totais_apli_ko(false);
        } else if (name === "totais_apli_mgo") {
          set_error_totais_apli_mgo(false);
        } else if (name === "totais_apli_cao") {
          set_error_totais_apli_cao(false);
        } else if (name === "totais_apli_so") {
          set_error_totais_apli_so(false);
        } else if (name === "totais_apli_b") {
          set_error_totais_apli_b(false);
        }
      } else {
        if (name === "elementos_n") {
          set_error_elementos_n(true);
        } else if (name === "elementos_po") {
          set_error_elementos_po(true);
        } else if (name === "elementos_ko") {
          set_error_elementos_ko(true);
        } else if (name === "elementos_mgo") {
          set_error_elementos_mgo(true);
        } else if (name === "elementos_cao") {
          set_error_elementos_cao(true);
        } else if (name === "elementos_so") {
          set_error_elementos_so(true);
        } else if (name === "elementos_b") {
          set_error_elementos_b(true);
        } else if (name === "totais_apli_homo_n") {
          set_error_totais_apli_homo_n(true);
        } else if (name === "totais_apli_homo_po") {
          set_error_totais_apli_homo_po(true);
        } else if (name === "totais_apli_homo_ko") {
          set_error_totais_apli_homo_ko(true);
        } else if (name === "totais_apli_homo_mgo") {
          set_error_totais_apli_homo_mgo(true);
        } else if (name === "totais_apli_homo_cao") {
          set_error_totais_apli_homo_cao(true);
        } else if (name === "totais_apli_homo_so") {
          set_error_totais_apli_homo_so(true);
        } else if (name === "totais_apli_homo_b") {
          set_error_totais_apli_homo_b(true);
        } else if (name === "totais_apli_n") {
          set_error_totais_apli_n(true);
        } else if (name === "totais_apli_po") {
          set_error_totais_apli_po(true);
        } else if (name === "totais_apli_ko") {
          set_error_totais_apli_ko(true);
        } else if (name === "totais_apli_mgo") {
          set_error_totais_apli_mgo(true);
        } else if (name === "totais_apli_cao") {
          set_error_totais_apli_cao(true);
        } else if (name === "totais_apli_so") {
          set_error_totais_apli_so(true);
        } else if (name === "totais_apli_b") {
          set_error_totais_apli_b(true);
        }
      }
      setExtraObject((prevRegisto: any) => ({
        ...prevRegisto,
        [name]: formatarNumero_ao_digitar(valorSemFormatar)
      }));
    } else {
      setExtraObject((prevRegisto: any) => ({
        ...prevRegisto,
        [name]: value,
      }));
    }
  };

  const handleSave = async () => {

    if (extraObject === undefined) {
      setMessage("Preencha a tabela antes de gravar");
      setOpenSnackError(true);
    } else try {
      setIsLoading(true);

      let res = await post(auth.token.cookie_token, "new_reg_actividades_5b_two", {
        payload: {
          id_atividade_two: 0,
          elementos_n: extraObject?.elementos_n === undefined ? null : desformatarNumero(extraObject.elementos_n),
          elementos_po: extraObject?.elementos_po === undefined ? null : desformatarNumero(extraObject.elementos_po),
          elementos_ko: extraObject?.elementos_ko === undefined ? null : desformatarNumero(extraObject.elementos_ko),
          elementos_mgo: extraObject?.elementos_mgo === undefined ? null : desformatarNumero(extraObject.elementos_mgo),
          elementos_cao: extraObject?.elementos_cao === undefined ? null : desformatarNumero(extraObject.elementos_cao),
          elementos_so: extraObject?.elementos_so === undefined ? null : desformatarNumero(extraObject.elementos_so),
          elementos_b: extraObject?.elementos_b === undefined ? null : desformatarNumero(extraObject.elementos_b),
          elementos_campp_opcao: extraObject?.elementos_campp_opcao === undefined ? "" : extraObject.elementos_campp_opcao,

          totais_apli_homo_n: extraObject?.totais_apli_homo_n === undefined ? null : desformatarNumero(extraObject.totais_apli_homo_n),
          totais_apli_homo_po: extraObject?.totais_apli_homo_po === undefined ? null : desformatarNumero(extraObject.totais_apli_homo_po),
          totais_apli_homo_ko: extraObject?.totais_apli_homo_ko === undefined ? null : desformatarNumero(extraObject.totais_apli_homo_ko),
          totais_apli_homo_mgo: extraObject?.totais_apli_homo_mgo === undefined ? null : desformatarNumero(extraObject.totais_apli_homo_mgo),
          totais_apli_homo_cao: extraObject?.totais_apli_homo_cao === undefined ? null : desformatarNumero(extraObject.totais_apli_homo_cao),
          totais_apli_homo_so: extraObject?.totais_apli_homo_so === undefined ? null : desformatarNumero(extraObject.totais_apli_homo_so),
          totais_apli_homo_b: extraObject?.totais_apli_homo_b === undefined ? null : desformatarNumero(extraObject.totais_apli_homo_b),
          totais_apli_homo_campp_opcao: extraObject?.totais_apli_homo_campp_opcao === undefined ? "" : extraObject.totais_apli_homo_campp_opcao,

          totais_apli_n: extraObject?.totais_apli_n === undefined ? null : desformatarNumero(extraObject.totais_apli_n),
          totais_apli_po: extraObject?.totais_apli_po === undefined ? null : desformatarNumero(extraObject.totais_apli_po),
          totais_apli_ko: extraObject?.totais_apli_ko === undefined ? null : desformatarNumero(extraObject.totais_apli_ko),
          totais_apli_mgo: extraObject?.totais_apli_mgo === undefined ? null : desformatarNumero(extraObject.totais_apli_mgo),
          totais_apli_cao: extraObject?.totais_apli_cao === undefined ? null : desformatarNumero(extraObject.totais_apli_cao),
          totais_apli_so: extraObject?.totais_apli_so === undefined ? null : desformatarNumero(extraObject.totais_apli_so),
          totais_apli_b: extraObject?.totais_apli_b === undefined ? null : desformatarNumero(extraObject.totais_apli_b),
          totais_apli_campp_opcao: extraObject?.totais_apli_campp_opcao === undefined ? "" : extraObject.totais_apli_campp_opcao,

          id_registo_activi: idCabecalho,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });
      if (res.status === 200) {
        setMessage("Gravado com sucesso!");

        setExtraObject(undefined);
        setExtraFields((prevRows) => {
          return [...prevRows, formatar_numeros_Atividades_ExtraTabela_5B(res.data.result)];
        });
        setOpenSnackSuccess(true);
        setCreateTable(false);
        set_error_elementos_n(false)
        set_error_elementos_po(false)
        set_error_elementos_ko(false)
        set_error_elementos_mgo(false)
        set_error_elementos_cao(false)
        set_error_elementos_so(false)
        set_error_elementos_b(false)
        set_error_totais_apli_homo_n(false)
        set_error_totais_apli_homo_po(false)
        set_error_totais_apli_homo_ko(false)
        set_error_totais_apli_homo_mgo(false)
        set_error_totais_apli_homo_cao(false)
        set_error_totais_apli_homo_so(false)
        set_error_totais_apli_homo_b(false)
        set_error_totais_apli_n(false)
        set_error_totais_apli_po(false)
        set_error_totais_apli_ko(false)
        set_error_totais_apli_mgo(false)
        set_error_totais_apli_cao(false)
        set_error_totais_apli_so(false)
        set_error_totais_apli_b(false)
        set_flag_editado(false)
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      func_print("handleSave", error, true);
      // if (error?.status === 409) {

      //   setMessage(error?.response.data.detail);
      //   setOpenSnackError(true);
      // } else {
      //   setMessage("Erro ao efetuar a sua operação!");
      //   setOpenSnackError(true);
      // }
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setOpenSnackError(true);

      setIsLoading(false);
    }
  };

  // EDITAR
  const handleEditExtra = (obj: IPage5B_Two) => {
    setExtraObject(obj);
  };

  const onInputChange_editar = (event: any) => {
    const { name, value } = event.target;

    const isCampoNumerico = camposNumericos.includes(name);

    set_flag_editado(true)


    if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));

      if (!isNaN(valorNumerico)) {
        if (name === "elementos_n") {
          set_error_elementos_n(false);
        } else if (name === "elementos_po") {
          set_error_elementos_po(false);
        } else if (name === "elementos_ko") {
          set_error_elementos_ko(false);
        } else if (name === "elementos_mgo") {
          set_error_elementos_mgo(false);
        } else if (name === "elementos_cao") {
          set_error_elementos_cao(false);
        } else if (name === "elementos_so") {
          set_error_elementos_so(false);
        } else if (name === "elementos_b") {
          set_error_elementos_b(false);
        } else if (name === "totais_apli_homo_n") {
          set_error_totais_apli_homo_n(false);
        } else if (name === "totais_apli_homo_po") {
          set_error_totais_apli_homo_po(false);
        } else if (name === "totais_apli_homo_ko") {
          set_error_totais_apli_homo_ko(false);
        } else if (name === "totais_apli_homo_mgo") {
          set_error_totais_apli_homo_mgo(false);
        } else if (name === "totais_apli_homo_cao") {
          set_error_totais_apli_homo_cao(false);
        } else if (name === "totais_apli_homo_so") {
          set_error_totais_apli_homo_so(false);
        } else if (name === "totais_apli_homo_b") {
          set_error_totais_apli_homo_b(false);
        } else if (name === "totais_apli_n") {
          set_error_totais_apli_n(false);
        } else if (name === "totais_apli_po") {
          set_error_totais_apli_po(false);
        } else if (name === "totais_apli_ko") {
          set_error_totais_apli_ko(false);
        } else if (name === "totais_apli_mgo") {
          set_error_totais_apli_mgo(false);
        } else if (name === "totais_apli_cao") {
          set_error_totais_apli_cao(false);
        } else if (name === "totais_apli_so") {
          set_error_totais_apli_so(false);
        } else if (name === "totais_apli_b") {
          set_error_totais_apli_b(false);
        }
      } else {
        if (name === "elementos_n") {
          set_error_elementos_n(true);
        } else if (name === "elementos_po") {
          set_error_elementos_po(true);
        } else if (name === "elementos_ko") {
          set_error_elementos_ko(true);
        } else if (name === "elementos_mgo") {
          set_error_elementos_mgo(true);
        } else if (name === "elementos_cao") {
          set_error_elementos_cao(true);
        } else if (name === "elementos_so") {
          set_error_elementos_so(true);
        } else if (name === "elementos_b") {
          set_error_elementos_b(true);
        } else if (name === "totais_apli_homo_n") {
          set_error_totais_apli_homo_n(true);
        } else if (name === "totais_apli_homo_po") {
          set_error_totais_apli_homo_po(true);
        } else if (name === "totais_apli_homo_ko") {
          set_error_totais_apli_homo_ko(true);
        } else if (name === "totais_apli_homo_mgo") {
          set_error_totais_apli_homo_mgo(true);
        } else if (name === "totais_apli_homo_cao") {
          set_error_totais_apli_homo_cao(true);
        } else if (name === "totais_apli_homo_so") {
          set_error_totais_apli_homo_so(true);
        } else if (name === "totais_apli_homo_b") {
          set_error_totais_apli_homo_b(true);
        } else if (name === "totais_apli_n") {
          set_error_totais_apli_n(true);
        } else if (name === "totais_apli_po") {
          set_error_totais_apli_po(true);
        } else if (name === "totais_apli_ko") {
          set_error_totais_apli_ko(true);
        } else if (name === "totais_apli_mgo") {
          set_error_totais_apli_mgo(true);
        } else if (name === "totais_apli_cao") {
          set_error_totais_apli_cao(true);
        } else if (name === "totais_apli_so") {
          set_error_totais_apli_so(true);
        } else if (name === "totais_apli_b") {
          set_error_totais_apli_b(true);
        }
      }
      setExtraObject((prevRegisto: any) => ({
        ...prevRegisto,
        [name]: formatarNumero_ao_digitar(valorSemFormatar)
      }));
    } else {
      setExtraObject((prevRegisto: any) => ({
        ...prevRegisto,
        [name]: value,
      }));
    }


  };

  const handleUpdate = async () => {

    try {
      setIsLoading(true);

      let res = await post(auth.token.cookie_token, `update_reg_actividades_5b_two`, {
        payload: {
          id_atividade_two: extraObject?.id_atividade_two,
          elementos_n: extraObject?.elementos_n === undefined ? null : desformatarNumero_return_null(extraObject.elementos_n),
          elementos_po: extraObject?.elementos_po === undefined ? null : desformatarNumero_return_null(extraObject.elementos_po),
          elementos_ko: extraObject?.elementos_ko === undefined ? null : desformatarNumero_return_null(extraObject.elementos_ko),
          elementos_mgo: extraObject?.elementos_mgo === undefined ? null : desformatarNumero_return_null(extraObject.elementos_mgo),
          elementos_cao: extraObject?.elementos_cao === undefined ? null : desformatarNumero_return_null(extraObject.elementos_cao),
          elementos_so: extraObject?.elementos_so === undefined ? null : desformatarNumero_return_null(extraObject.elementos_so),
          elementos_b: extraObject?.elementos_b === undefined ? null : desformatarNumero_return_null(extraObject.elementos_b),
          elementos_campp_opcao: extraObject?.elementos_campp_opcao === undefined ? "" : extraObject.elementos_campp_opcao,

          totais_apli_homo_n: extraObject?.totais_apli_homo_n === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_homo_n),
          totais_apli_homo_po: extraObject?.totais_apli_homo_po === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_homo_po),
          totais_apli_homo_ko: extraObject?.totais_apli_homo_ko === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_homo_ko),
          totais_apli_homo_mgo: extraObject?.totais_apli_homo_mgo === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_homo_mgo),
          totais_apli_homo_cao: extraObject?.totais_apli_homo_cao === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_homo_cao),
          totais_apli_homo_so: extraObject?.totais_apli_homo_so === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_homo_so),
          totais_apli_homo_b: extraObject?.totais_apli_homo_b === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_homo_b),
          totais_apli_homo_campp_opcao: extraObject?.totais_apli_homo_campp_opcao === undefined ? "" : extraObject.totais_apli_homo_campp_opcao,

          totais_apli_n: extraObject?.totais_apli_n === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_n),
          totais_apli_po: extraObject?.totais_apli_po === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_po),
          totais_apli_ko: extraObject?.totais_apli_ko === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_ko),
          totais_apli_mgo: extraObject?.totais_apli_mgo === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_mgo),
          totais_apli_cao: extraObject?.totais_apli_cao === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_cao),
          totais_apli_so: extraObject?.totais_apli_so === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_so),
          totais_apli_b: extraObject?.totais_apli_b === undefined ? null : desformatarNumero_return_null(extraObject.totais_apli_b),
          totais_apli_campp_opcao: extraObject?.totais_apli_campp_opcao === undefined ? "" : extraObject.totais_apli_campp_opcao,

          id_registo_activi: idCabecalho,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      }
      );
      if (res.status === 200) {
        setMessage("Registado com sucesso!");
        const updatedRows = extraFields.map((row) => {
          if (row.id_atividade_two === extraObject?.id_atividade_two) {
            return formatar_numeros_Atividades_ExtraTabela_5B(res.data.result)
          } else {
            return { ...row }
          }
        });
        setExtraFields(updatedRows !== undefined ? updatedRows : []);
        setExtraObject(undefined)
        setOpenSnackSuccess(true);
        set_error_elementos_n(false)
        set_error_elementos_po(false)
        set_error_elementos_ko(false)
        set_error_elementos_mgo(false)
        set_error_elementos_cao(false)
        set_error_elementos_so(false)
        set_error_elementos_b(false)
        set_error_totais_apli_homo_n(false)
        set_error_totais_apli_homo_po(false)
        set_error_totais_apli_homo_ko(false)
        set_error_totais_apli_homo_mgo(false)
        set_error_totais_apli_homo_cao(false)
        set_error_totais_apli_homo_so(false)
        set_error_totais_apli_homo_b(false)
        set_error_totais_apli_n(false)
        set_error_totais_apli_po(false)
        set_error_totais_apli_ko(false)
        set_error_totais_apli_mgo(false)
        set_error_totais_apli_cao(false)
        set_error_totais_apli_so(false)
        set_error_totais_apli_b(false)
        set_flag_editado(false)
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      func_print("handleSaveEditExtra", error, true);
      if (error?.status === 409) {

        setMessage(error?.response.data.detail);
        setOpenSnackError(true);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    }

  };

  // Delete
  const handleClickOpenDeleteExtra = (obj: IPage5B_Two) => {
    setExtraObject(obj)

    setOpenDeleteExtra(true);
  };
  const handleDeleteExtra = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_actividades_5b_two/${extraObject?.id_atividade_two}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDeleteExtra(false);
        setExtraFields((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_atividade_two !== extraObject?.id_atividade_two),
        ]);
        setExtraObject(undefined)

        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDeleteAnalise", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* Se não houver registos mostra tabela vazia e botão criar  */}
      {extraFields.length <= 0 && createTable === false && (
        <TableBody>
          <TableRow>
            <StyledTableHead colSpan={5}>
              Elementos fornecidos pelo solo (cf. Análise de terras)
            </StyledTableHead>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell rowSpan={3}>
              {is_historico === true ? <></> :

                <BarraDeFerramentas
                  mostrarBotaoNovo
                  textoBotaoNovo="Registar"
                  aoClicarNovo={() => setCreateTable(true)}
                />}
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableHead colSpan={5}>
              Totais aplicados na subparcela ou na zona homogénea (kg)
            </StyledTableHead>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableHead colSpan={5}>
              Totais aplicados por hectare (kg/ha)
            </StyledTableHead>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
        </TableBody>
      )}

      {/* Se não houver registos e botão criar === true mostra tabela para criar  */}
      {extraFields.length <= 0 && createTable && (
        <TableBody>
          <TableRow>
            <StyledTableHead colSpan={5}>
              Elementos fornecidos pelo solo (cf. Análise de terras)
            </StyledTableHead>
            <StyledTableCell>
              <CustomTextField
                name="elementos_n"
                value={extraObject?.elementos_n}
                onChange={onInputChange}
                error={error_elementos_n}
                helperText={error_elementos_n ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_po"
                value={extraObject?.elementos_po}
                onChange={onInputChange}
                error={error_elementos_po}
                helperText={error_elementos_po ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_ko"
                value={extraObject?.elementos_ko}
                onChange={onInputChange}
                error={error_elementos_ko}
                helperText={error_elementos_ko ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_mgo"
                value={extraObject?.elementos_mgo}
                onChange={onInputChange}
                error={error_elementos_mgo}
                helperText={error_elementos_mgo ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_cao"
                value={extraObject?.elementos_cao}
                onChange={onInputChange}
                error={error_elementos_cao}
                helperText={error_elementos_cao ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_so"
                value={extraObject?.elementos_so}
                onChange={onInputChange}
                error={error_elementos_so}
                helperText={error_elementos_so ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_b"
                value={extraObject?.elementos_b}
                onChange={onInputChange}
                error={error_elementos_b}
                helperText={error_elementos_b ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_campp_opcao"
                value={extraObject?.elementos_campp_opcao}
                onChange={onInputChange}
              />
            </StyledTableCell>

            <StyledTableCell rowSpan={3}>
              <ButtonCadernos
                mostrarBotaoGravar
                aoClicarGravar={() => handleSave()}
                mostrarBotaoCancelar
                aoClicarCancelar={() => {
                  if (flag_editado) {
                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                  } else {
                    handleCancel()
                  }
                }}
              />
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableHead colSpan={5}>
              Totais aplicados na subparcela ou na zona homogénea (kg)
            </StyledTableHead>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_homo_n"
                value={extraObject?.totais_apli_homo_n}
                onChange={onInputChange}
                error={error_totais_apli_homo_n}
                helperText={error_totais_apli_homo_n ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_homo_po"
                value={extraObject?.totais_apli_homo_po}
                onChange={onInputChange}
                error={error_totais_apli_homo_po}
                helperText={error_totais_apli_homo_po ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_homo_ko"
                value={extraObject?.totais_apli_homo_ko}
                onChange={onInputChange}
                error={error_totais_apli_homo_ko}
                helperText={error_totais_apli_homo_ko ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_homo_mgo"
                value={extraObject?.totais_apli_homo_mgo}
                onChange={onInputChange}
                error={error_totais_apli_homo_mgo}
                helperText={error_totais_apli_homo_mgo ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_homo_cao"
                value={extraObject?.totais_apli_homo_cao}
                onChange={onInputChange}
                error={error_totais_apli_homo_cao}
                helperText={error_totais_apli_homo_cao ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_homo_so"
                value={extraObject?.totais_apli_homo_so}
                onChange={onInputChange}
                error={error_totais_apli_homo_so}
                helperText={error_totais_apli_homo_so ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_homo_b"
                value={extraObject?.totais_apli_homo_b}
                onChange={onInputChange}
                error={error_totais_apli_homo_b}
                helperText={error_totais_apli_homo_b ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_homo_campp_opcao"
                value={extraObject?.totais_apli_homo_campp_opcao}
                onChange={onInputChange}
              />
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableHead colSpan={5}>
              Totais aplicados por hectare (kg/ha)
            </StyledTableHead>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_n"
                value={extraObject?.totais_apli_n}
                onChange={onInputChange}
                error={error_totais_apli_n}
                helperText={error_totais_apli_n ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_po"
                value={extraObject?.totais_apli_po}
                onChange={onInputChange}
                error={error_totais_apli_po}
                helperText={error_totais_apli_po ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_ko"
                value={extraObject?.totais_apli_ko}
                onChange={onInputChange}
                error={error_totais_apli_ko}
                helperText={error_totais_apli_ko ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_mgo"
                value={extraObject?.totais_apli_mgo}
                onChange={onInputChange}
                error={error_totais_apli_mgo}
                helperText={error_totais_apli_mgo ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_cao"
                value={extraObject?.totais_apli_cao}
                onChange={onInputChange}
                error={error_totais_apli_cao}
                helperText={error_totais_apli_cao ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_so"
                value={extraObject?.totais_apli_so}
                onChange={onInputChange}
                error={error_totais_apli_so}
                helperText={error_totais_apli_so ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_b"
                value={extraObject?.totais_apli_b}
                onChange={onInputChange}
                error={error_totais_apli_b}
                helperText={error_totais_apli_b ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_apli_campp_opcao"
                value={extraObject?.totais_apli_campp_opcao}
                onChange={onInputChange}
              />
            </StyledTableCell>
          </TableRow>
        </TableBody>
      )}

      {/* Se houver registos mostra tabela para editar  */}
      {extraFields.length > 0 &&
        extraFields.map((ext, key) => {
          return (
            <TableBody key={key}>
              {extraObject?.id_atividade_two === ext.id_atividade_two ? (
                <>
                  <TableRow>
                    <StyledTableHead colSpan={5}>
                      Elementos fornecidos pelo solo (cf. Análise de terras)
                    </StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="elementos_n"
                        value={extraObject?.elementos_n}
                        onChange={onInputChange_editar}
                        error={error_elementos_n}
                        helperText={error_elementos_n ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="elementos_po"
                        value={extraObject?.elementos_po}
                        onChange={onInputChange_editar}
                        error={error_elementos_po}
                        helperText={error_elementos_po ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="elementos_ko"
                        value={extraObject?.elementos_ko}
                        onChange={onInputChange_editar}
                        error={error_elementos_ko}
                        helperText={error_elementos_ko ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="elementos_mgo"
                        value={extraObject?.elementos_mgo}
                        onChange={onInputChange_editar}
                        error={error_elementos_mgo}
                        helperText={error_elementos_mgo ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="elementos_cao"
                        value={extraObject?.elementos_cao}
                        onChange={onInputChange_editar}
                        error={error_elementos_cao}
                        helperText={error_elementos_cao ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="elementos_so"
                        value={extraObject?.elementos_so}
                        onChange={onInputChange_editar}
                        error={error_elementos_so}
                        helperText={error_elementos_so ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="elementos_b"
                        value={extraObject?.elementos_b}
                        onChange={onInputChange_editar}
                        error={error_elementos_b}
                        helperText={error_elementos_b ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="elementos_campp_opcao"
                        value={extraObject?.elementos_campp_opcao}
                        onChange={onInputChange_editar}
                      />
                    </StyledTableCell>
                    <StyledTableCell rowSpan={3}>
                      <ButtonCadernos
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleUpdate()}
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            handleCancel()
                          }
                        }}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead colSpan={5}>
                      Totais aplicados na subparcela ou na zona homogénea
                      (kg)
                    </StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_homo_n"
                        value={extraObject?.totais_apli_homo_n}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_homo_n}
                        helperText={error_totais_apli_homo_n ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_homo_po"
                        value={extraObject?.totais_apli_homo_po}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_homo_po}
                        helperText={error_totais_apli_homo_po ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_homo_ko"
                        value={extraObject?.totais_apli_homo_ko}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_homo_ko}
                        helperText={error_totais_apli_homo_ko ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_homo_mgo"
                        value={extraObject?.totais_apli_homo_mgo}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_homo_mgo}
                        helperText={error_totais_apli_homo_mgo ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_homo_cao"
                        value={extraObject?.totais_apli_homo_cao}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_homo_cao}
                        helperText={error_totais_apli_homo_cao ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_homo_so"
                        value={extraObject?.totais_apli_homo_so}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_homo_so}
                        helperText={error_totais_apli_homo_so ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_homo_b"
                        value={extraObject?.totais_apli_homo_b}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_homo_b}
                        helperText={error_totais_apli_homo_b ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_homo_campp_opcao"
                        value={extraObject?.totais_apli_homo_campp_opcao}
                        onChange={onInputChange_editar}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead colSpan={5}>
                      Totais aplicados por hectare (kg/ha)
                    </StyledTableHead>

                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_n"
                        value={extraObject?.totais_apli_n}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_n}
                        helperText={error_totais_apli_n ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_po"
                        value={extraObject?.totais_apli_po}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_po}
                        helperText={error_totais_apli_po ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_ko"
                        value={extraObject?.totais_apli_ko}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_ko}
                        helperText={error_totais_apli_ko ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_mgo"
                        value={extraObject?.totais_apli_mgo}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_mgo}
                        helperText={error_totais_apli_mgo ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_cao"
                        value={extraObject?.totais_apli_cao}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_cao}
                        helperText={error_totais_apli_cao ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_so"
                        value={extraObject?.totais_apli_so}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_so}
                        helperText={error_totais_apli_so ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_b"
                        value={extraObject?.totais_apli_b}
                        onChange={onInputChange_editar}
                        error={error_totais_apli_b}
                        helperText={error_totais_apli_b ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="totais_apli_campp_opcao"
                        value={extraObject?.totais_apli_campp_opcao}
                        onChange={onInputChange_editar}
                      />
                    </StyledTableCell>
                  </TableRow>
                </>
              ) : (
                <>
                  <TableRow>
                    <StyledTableHead colSpan={5}>
                      Elementos fornecidos pelo solo (cf. Análise de terras)
                    </StyledTableHead>
                    <StyledTableCell>{ext.elementos_n} </StyledTableCell>
                    <StyledTableCell>{ext.elementos_po}</StyledTableCell>
                    <StyledTableCell>{ext.elementos_ko}</StyledTableCell>
                    <StyledTableCell>{ext.elementos_mgo}</StyledTableCell>
                    <StyledTableCell>{ext.elementos_cao}</StyledTableCell>
                    <StyledTableCell>{ext.elementos_so}</StyledTableCell>
                    <StyledTableCell>{ext.elementos_b}</StyledTableCell>
                    <StyledTableCell>
                      {ext.elementos_campp_opcao}
                    </StyledTableCell>
                    <StyledTableCell rowSpan={3}>
                      {is_historico === true ? <></> :

                        <ButtonCadernos
                          mostrarBotaoEditar
                          aoClicarEditar={() => handleEditExtra(ext)}
                          mostrarBotaoApagar
                          aoClicarApagar={() => handleClickOpenDeleteExtra(ext)}
                        />}
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead colSpan={5}>
                      Totais aplicados na subparcela ou na zona homogénea
                      (kg)
                    </StyledTableHead>
                    <StyledTableCell> {ext.totais_apli_homo_n} </StyledTableCell>
                    <StyledTableCell>  {ext.totais_apli_homo_po} </StyledTableCell>
                    <StyledTableCell> {ext.totais_apli_homo_ko} </StyledTableCell>
                    <StyledTableCell> {ext.totais_apli_homo_mgo} </StyledTableCell>
                    <StyledTableCell> {ext.totais_apli_homo_cao} </StyledTableCell>
                    <StyledTableCell> {ext.totais_apli_homo_so} </StyledTableCell>
                    <StyledTableCell> {ext.totais_apli_homo_b} </StyledTableCell>
                    <StyledTableCell> {ext.totais_apli_homo_campp_opcao} </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead colSpan={5}>
                      Totais aplicados por hectare (kg/ha)
                    </StyledTableHead>
                    <StyledTableCell>{ext.totais_apli_n}</StyledTableCell>
                    <StyledTableCell>{ext.totais_apli_po}</StyledTableCell>
                    <StyledTableCell>{ext.totais_apli_ko}</StyledTableCell>
                    <StyledTableCell>{ext.totais_apli_mgo}</StyledTableCell>
                    <StyledTableCell>{ext.totais_apli_cao}</StyledTableCell>
                    <StyledTableCell>{ext.totais_apli_so}</StyledTableCell>
                    <StyledTableCell>{ext.totais_apli_b}</StyledTableCell>
                    <StyledTableCell>
                      {ext.totais_apli_campp_opcao}
                    </StyledTableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          );
        })}


      <ConfirmDialog
        open={openDeleteAtividades}
        onClose={() => setOpenDeleteExtra(false)}
        onConfirm={handleDeleteExtra}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </>
  );
};
